<template>
  <div class="form-element" :class="{ '-login': isLoginPage }">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <input v-letter="isLetter" v-numeric="isNumeric" class="form-element__input" :class="classObject" type="text" :placeholder="placeholder"  minlength="11"
      maxlength="11" :name="title" autocomplete="off" @input="changed" @focus="makeWriteable" @blur="makeReadable" v-model.trim="val" :readonly="read" />
    <div class="form-element__message" :class="{ '-error': isError }" v-if="message">{{ message }}</div>

  </div>
</template>

<script>
import { letter, numeric } from '@/directives/'
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    isLetter: {
      type: Boolean,
      default: false
    },
    isSecondary: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    isHalf: {
      type: Boolean,
      default: false
    },
    isQuarter: {
      type: Boolean,
      default: false
    },
    isNumeric: {
      type: Boolean,
      default: false
    },
    isBorder: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      val: this.value,
      isLoginPage: this.$route.meta.layout == 'login',
      read: true
    }
  },
  computed: {
    classObject: function () {
      let list = {
        '-secondary': this.isSecondary,
        '-error': this.isError,
        '-half': this.isHalf,
        '-quarter': this.isQuarter,
        '-border': this.isBorder
      }

      return list
    }
  },
  watch: {
    value: function (val) {
      this.val = val
    }
  },
  directives: { letter, numeric },
  methods: {

    changed: function (e) {
      this.$emit('input', e.target.value)

      return e.target.value
    },
    makeWriteable: function () {
      this.read = false
    },
    makeReadable: function () {
      this.read = true
    }
  }
}
</script>